import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import PropTypes from 'prop-types';

import AuthLayout from "../../shared/containers/AuthLayout";
import {getSeniors} from "../members/actions/seniorsAction";
import * as videoAction from "./actions/videoAction";
import ContactList from "../../shared/components/ContactList";
import {
  RC_STATUS_AWAY,
  RC_STATUS_BUSY,
  RC_STATUS_OFFLINE,
  RC_STATUS_ONLINE,
  RC_USER_PREFIX_T
} from "../../shared/modules/rocketChat/constants";
import * as notificationAction
  from "../../shared/modules/notification/actions/notificationsAction";
import {
  NOTIFICATION_ERROR,
  NOTIFICATION_WARNING
} from "../../shared/modules/notification/constants";
import {TW_ROOM_REMOVE} from "../../shared/modules/twilio/constants/actionTypes";
import {VIDEO_STOP} from "./constants/actionTypes";
import {isCordova} from "../../app";
import {PLATFORM_IOS, ANALYTICS_SPECS} from "../../shared/constants";
import {sendAnalyticsEvent} from "../../shared/actions/analytics";


class VideoContainer extends React.Component {

  static propTypes = {
    onLeft: PropTypes.func,
    onRight: PropTypes.func,
    seniors: PropTypes.array,
    twilio: PropTypes.object,
    video: PropTypes.object
  };

  state = {isRoomDefined: false};

  componentDidMount() {
    this.props.dispatch(getSeniors());
    if (isCordova() && cordova.platformId === PLATFORM_IOS) {
      document.addEventListener(
        'twilioVideoClosed',
        () => {
          this.props.dispatch({type: VIDEO_STOP });
          this.props.dispatch({type: TW_ROOM_REMOVE});
          this.props.dispatch(videoAction.stop());
        }
      );
    }

    sendAnalyticsEvent(ANALYTICS_SPECS.DIARY.NAME, ANALYTICS_SPECS.DIARY.EVENTS.START_VIDEO_CALL);
  }

  componentWillReceiveProps(nextProps) {
    if (("video" in nextProps.twilio) && ("room" in nextProps.twilio.video)) {
      const {room} = nextProps.twilio.video;

      if (room !== null &&
        typeof room === "object" &&
        !this.state.isRoomDefined &&
        !(Object.keys(room).length === 0 &&
          room.constructor === Object)
      ) {
        this.onVideoConnection(room);
      }
    }
  }

  componentWillUnmount() {
    if (this.state.isRoomDefined) {
      this.props.twilio.video.room.disconnect();
    }
  }

  attachTracks(tracks, container) {
    tracks.forEach((track) => {
      container.appendChild(track.attach());
    });
  }

  attachParticipantTracks(participant, container) {
    const tracks = Array.from(participant.tracks.values());

    this.attachTracks(tracks, container);
  }

  detachTracks(tracks) {
    tracks.forEach((track) => {
      track.detach().forEach((detachedElement) => {
        detachedElement.remove();
      });
    });
  }

  detachParticipantTracks(participant) {
    const tracks = Array.from(participant.tracks.values());

    this.detachTracks(tracks);
  }

  onVideoConnection(room) {
    this.setState({isRoomDefined: true});
    room.localParticipant.tracks.forEach((track) => {
      this.refs.localMedia.appendChild(track.attach());
    });
    room.participants.forEach((participant) => {
      this.attachParticipantTracks(participant, this.refs.remoteMedia);
    });
    room.on('trackAdded', (track, participant) => {
      this.props.dispatch(videoAction.join());
      this.attachTracks([track], this.refs.remoteMedia);
    });
    room.on('trackRemoved', (track, participant) => {
      this.detachTracks([track]);
    });
    room.on('participantDisconnected', (participant) => {
      this.detachParticipantTracks(participant);
      if (!room.participants.size) {
        this.props.dispatch(videoAction.stopped());
        this.setState({isRoomDefined: false});

        sendAnalyticsEvent(ANALYTICS_SPECS.DIARY.NAME, ANALYTICS_SPECS.DIARY.EVENTS.END_VIDEO_CALL);
      }
    });
    room.on('disconnected', () => {
      this.setState({isRoomDefined: false});
    });
  }

  render() {
    const {seniors} = this.props;

    return (
      <AuthLayout title={__("Start a video call")}
                  description={__("Who do you want to call?")}>
        {seniors.length > 0 && <ContactList
          seniorGroups={[{"title": __("Seniors"), "list": seniors}]}
          onMemberClick={this.props.onStartClick}
          left={this.props.onLeft}
          right={this.props.onRight}
        />}
        {this.props.video.isEstablished &&
        <div id="video">
          <hr/>
          <div id="remote-media" className="remote-media" ref="remoteMedia"/>
          <div id="local-media" className="local-media" ref="localMedia"/>
          <button className="buttonSecondary hangUpButton"
                  onClick={this.props.onStopClick}>{__("End a call")}
          </button>
        </div>}
      </AuthLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    seniors: state.seniors,
    user: state.user,
    twilio: state.twilio,
    video: state.video,
    rocketChat: state.rocketChat
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dispatch,
    onStopClick: () => {
      return dispatch(videoAction.stop())
    },
    onStartClick: (user) => {
      sendAnalyticsEvent(ANALYTICS_SPECS.DIARY.NAME, ANALYTICS_SPECS.DIARY.EVENTS.SELECT_VIDEO_CALL_CONTACT);
      if (ownProps.user.isOnline) {
        const clickedUserID = RC_USER_PREFIX_T + user;
        const clickedItemSenior = Object.values(ownProps.seniors)
          .find((item) => item.prof_id === user);
        const clickedRCSenior = Object.values(ownProps.rocketChat.users)
          .find((item) => item.username === clickedUserID);

        if (ownProps.rocketChat.isConnected) {
          if (clickedRCSenior && clickedRCSenior.status === RC_STATUS_ONLINE) {
            if (!ownProps.video.isInitiated) {
              dispatch(videoAction.initiate());
              if (ownProps.video.isOnline) {
                dispatch(videoAction.start(clickedUserID))
              } else {
                dispatch(
                  notificationAction.addNotification(
                    __("You are offline and can not make calls."),
                    NOTIFICATION_WARNING
                  )
                );
              }
            }
          } else {
            dispatch(
              notificationAction.addNotification(
                __("%user% is currently offline and can not be called.")
                  .replace('%user%', `${clickedItemSenior.firstname} ${clickedItemSenior.lastname}`),
                NOTIFICATION_ERROR
              )
            );
          }
        } else {
          dispatch(
            notificationAction.addNotification(
              __("Please wait a few seconds until the connection is made."),
              NOTIFICATION_WARNING
            )
          );
        }
      } else {
        dispatch(
          notificationAction.addNotification(
            __("You are offline and can not make calls."),
            NOTIFICATION_WARNING
          )
        );
      }
    }
  };
};

const mergeState = (state, dispatch, own) => {
  return {
    ...own,
    ...state,
    ...dispatch,
    onLeft: (user) => {
      const username = RC_USER_PREFIX_T + user;
      const userStatus = own.user.isOnline
        ? (own.rocketChat.isConnected
          ? ((Object.values(state.rocketChat.users).find((rocketChatUser) => rocketChatUser.username === username) || {})
            .status || RC_STATUS_OFFLINE)
          : RC_STATUS_BUSY)
        : RC_STATUS_AWAY;

      return (
        <div className={userStatus}>
        </div>
      );
    },
    onRight: (user) => {
      const username = RC_USER_PREFIX_T + user;

      return (
        <div>
          {username in state.video.missed && state.video.missed[username] > 0
            ? <span
              className="missedContactCount">{state.video.missed[username]}</span>
            : ''}
          <i className="fa fa-video-camera"/>
        </div>

      );
    }
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeState)(VideoContainer));
